<template>
  <div>
    <div class="col-12">
      <p class="my-4 subtitulo-form">Asignación de escenario</p>
      <div class="row">
        <div class="col-md-12 text-center">
          <b-form-radio
            class="my-2"
            v-for="scenario in list.scenarios"
            v-model="pointsale.pro_scene_id"
            :key="scenario.id"
            :value="scenario.id"
            v-show="scenario.id == '' || scenario.id == null ? false : true"
            size="lg"
          >
            <span class="span-radio-buton ml-3">{{ scenario.name }}</span>
          </b-form-radio>
        </div>
      </div>
    </div>
    <div class="col-12 text-center mt-4">
      <SaveModal
        :disabled="
          pointsale.pro_scene_id == '' || pointsale.pro_scene_id == null
            ? true
            : false
        "
        @click="confirmar"
        :loading="loadingSave"
      >
        Confirmar
      </SaveModal>
    </div>
  </div>
</template>

<script>
import SaveModal from "@/components/core/button/save-modal.vue";
export default {
  name: "tipspointsale-form",
  components: {
    SaveModal,
  },
  props: {
    list: {
      type: Object,
      default: null,
    },
    loadingSave: {
      type: Boolean,
      default: false,
    },
    pointsale: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      escenario: null,
    };
  },
  emits: ["confirmar"],
  methods: {
    confirmar() {
      this.$emit("confirmar");
    },
  },
};
</script>

<style>
.subtitulo-form {
  font-family: "Ubuntu";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #455a64;
}
.span-radio-buton {
  font-family: "Ubuntu";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #546e7a;
}
</style>